import { render, staticRenderFns } from "./PolicyForm.vue?vue&type=template&id=4817e19e&scoped=true"
import script from "./PolicyForm.vue?vue&type=script&lang=js"
export * from "./PolicyForm.vue?vue&type=script&lang=js"
import style0 from "./PolicyForm.vue?vue&type=style&index=0&id=4817e19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817e19e",
  null
  
)

export default component.exports